(function(){
  if(window.__cpExtras) return; window.__cpExtras=1;
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Holo shine: follow the pointer */
  if(window.matchMedia&&matchMedia('(hover: hover)').matches&&!reduce){
    var raf=0,last=null;
    document.addEventListener('pointermove',function(e){
      var m=e.target.closest&&e.target.closest('.product-card-wrapper .card__media .media');
      if(!m) return; last={m:m,x:e.clientX,y:e.clientY};
      if(raf) return;
      raf=requestAnimationFrame(function(){
        raf=0; if(!last) return;
        var r=last.m.getBoundingClientRect();
        last.m.style.setProperty('--mx',Math.max(0,Math.min(100,(last.x-r.left)/r.width*100))+'%');
        last.m.style.setProperty('--my',Math.max(0,Math.min(100,(last.y-r.top)/r.height*100))+'%');
      });
    },{passive:true});
  }

  function ready(fn){if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fn);else fn();}
  ready(function(){
    /* Cart icon pulse */
    var bubble=document.getElementById('cart-icon-bubble');
    if(bubble&&'MutationObserver' in window){
      var count=function(){var c=bubble.querySelector('.cart-count-bubble');return c?c.textContent.replace(/\D/g,''):'0';};
      var prev=count();
      new MutationObserver(function(){
        var now=count(); if(now===prev) return; prev=now;
        bubble.classList.remove('cp-pulse'); void bubble.offsetWidth; bubble.classList.add('cp-pulse');
        setTimeout(function(){bubble.classList.remove('cp-pulse');},800);
      }).observe(bubble,{childList:true,subtree:true,characterData:true});
    }

    /* Back-to-top rocket */
    var top=document.createElement('button');
    top.className='cp-top'; top.type='button'; top.setAttribute('aria-label','Back to top');
    top.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 2c3 2.5 5 6 5 10l-2 3H9l-2-3c0-4 2-7.500 5-10z"/><circle cx="12" cy="9" r="1.600"/><path d="M9 15l-3 3 3 .5M15 15l3 3-3 .5M12 17v4"/></svg>';
    top.addEventListener('click',function(){window.scrollTo({top:0,behavior:reduce?'auto':'smooth'});});
    document.body.appendChild(top);
    var tick=false;
    window.addEventListener('scroll',function(){
      if(tick) return; tick=true;
      requestAnimationFrame(function(){tick=false;top.classList.toggle('on',window.scrollY>700);});
    },{passive:true});

    /* Shooting star (desktop only, every so often) */
    if(!reduce&&window.innerWidth>=750){
      (function loop(){
        setTimeout(function(){
          if(!document.hidden){
            var s=document.createElement('div'); s.className='cp-star';
            s.style.left=(Math.random()*55+5)+'%'; s.style.top=(Math.random()*35+4)+'%';
            document.body.appendChild(s); void s.offsetWidth; s.classList.add('go');
            setTimeout(function(){s.remove();},1300);
          }
          loop();
        },9000+Math.random()*9000);
      })();
    }
  });
})();
